// Kulüp girişi Rezervasyonlar penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.clubEntryReservations';

export const salesClubEntryReservationsGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Rezervasyonla giriş nasıl yapılır?'),
  intro: t(`${G}.intro`, 'QR menüden (online) gelen bilet rezervasyonlarını listeler; ödemesi alınmış rezervasyonda kart okutup misafirlerin girişini yaparsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Tarih, arama ve rezervasyon listesi'),
    footer: t(`${G}.regions.footer`, 'Kapat'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu pencere ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Online alınan bilet rezervasyonlarını gösterir. Bilet ücreti rezervasyon sırasında online ödendiği için burada yeniden tahsil edilmez; yalnız kart verilir ve (ekranda açıksa) depozito alınır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Rezervasyonu bulun'),
      text: t(`${G}.s2.text`, 'Pencere bugünün rezervasyonlarıyla açılır. "Başlangıç Tarihi" veya "Bitiş Tarihi" değişince liste kendiliğinden yenilenir. Arama kutusuna PNR, isim veya ad-soyad yazıp Enter\'a basın; "Yenile" listeyi yeniden yükler.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Satırı inceleyin'),
      text: t(`${G}.s3.text`, 'Her satırda PNR / rezervasyon no, rezervasyon günü, yetkili kişi, misafir sayısı, tutar, ödeme ve durum görünür. Satıra tıklayınca misafirler, bilet / ürünler ve iletişim bilgileri açılır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Giriş yapın, kartları okutun'),
      text: t(`${G}.s4.text`, 'Satırın sonundaki ⋮ menüsünden "Giriş Yap"ı seçin. Açılan "Kart Okutma" penceresinde misafir sayısı kadar kart okutun ve "Girişi Tamamla"ya basın. Kartlar rezervasyona bağlanır, her kart için oturum açılır ve rezervasyon kullanılmış olarak işaretlenir.'),
      tips: [
        t(`${G}.s4.tip1`, '"Giriş Yap" yalnız ödemesi "Ödendi" olan, daha önce kullanılmamış, iptal veya ret edilmemiş rezervasyonlarda açıktır.'),
        t(`${G}.s4.tip2`, 'Kullanılmış bir rezervasyonda "Bu rezervasyon daha önce kullanıldı" uyarısı çıkar.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Depozitoyu alın'),
      text: t(`${G}.s5.text`, 'Ekranda depozito açıksa kart okutma penceresinde depozito ödeme yöntemini (Nakit / POS) seçersiniz; tahsil edilecek tutar yalnız depozitodur. Nakit depozito ekranın nakit kasasına kaydedilir. POS seçilirse pencere kapanır, depozito satış ekranında normal POS ödemesiyle alınır ve ödeme başarılı olunca kartlar atanır.'),
    },
  ],
});
